'use client'

import { ArrowRightIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

export const StickyCallButton = () => {
    return (
        <div className="fixed bottom-4 left-4 right-4 z-50 md:hidden">
            <a
                href="#contact"
                className={cn(
                    'flex items-center justify-center gap-3 px-6 py-4 rounded-lg shadow-2xl',
                    'bg-primary text-primary-foreground font-medium text-base',
                    'hover:bg-primary/80 transition-all duration-300',
                    'border border-primary-foreground/20 w-full'
                )}
            >
                <span className="leading-tight text-center">Get Your Clawbiz Set Up</span>
                <ArrowRightIcon className="w-5 h-5 shrink-0" />
            </a>
        </div>
    )
}
